import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"filter\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1a.5.5 0 00-.354.854l4.355 5.853V12.5a.5.5 0 00.146.354l3 3a.5.5 0 00.854-.354V7.681l4.383-5.86A.5.5 0 0014 1H2zm5.001 6.5a.5.5 0 00-.146-.354L3 2h10L9.117 7.18A.5.5 0 009 7.5v6.793l-2-2V7.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol